import { Component, ChangeDetectorRef } from '@angular/core';
import { ControlWidget } from '../angular2-schema-form-shim';
import { JSONSchema } from '../types/json-schema';
import { isWidgetRequired } from './overrides';
import { DomSanitizer } from '@angular/platform-browser';

@Component( {
  selector: 'sp-message-widget',
  templateUrl: './message.widget.html',
} )
export class MessageWidget extends ControlWidget {
  schema: JSONSchema;

  constructor( private domSanitizer: DomSanitizer, private ref: ChangeDetectorRef ) {
    super();
  }

  get widget() {
    let widget = this.schema.widget;
    return typeof widget === 'string' ? { id: widget } : widget;
  }

  get message() {
    return this.domSanitizer.bypassSecurityTrustHtml( this.widget.content );
  }

  get required() {
    return isWidgetRequired( this );
  }

  ngAfterViewInit() {
    // Detatch iframes to prevent endless reloading during change detection
    if ( /<iframe /.test( this.message as string ) ) {
      this.ref.detach();
    }
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/message.widget.ts